export var ProcessOrderActionEnum;
(function (ProcessOrderActionEnum) {
    ProcessOrderActionEnum["SPEND_POINTS"] = "spend-points";
    ProcessOrderActionEnum["EARN_POINTS"] = "earn-points";
})(ProcessOrderActionEnum || (ProcessOrderActionEnum = {}));
//# sourceMappingURL=ProcessOrderActionEnum.js.map